(function () {
  "use strict";
  if (window.TMWebwinkelkeurRating) {
    window.TMWebwinkelkeurRating.refresh();
    return;
  }

  var cfg = window.TM_WWK_CONFIG || {};
  if (!cfg.shopId || !cfg.publicCode) return;
  var selector = "[data-tm-wwk-score], [data-tm-wwk-score-value]";
  var cacheKey = "tm_wwk_shop_rating_v4_" + cfg.shopId;
  var cacheTTL = 24 * 60 * 60 * 1000;
  var currentScore = null;
  var fresh = false;
  var attempts = 0;
  var inFlight = false;
  var retryTimer = null;
  var pendingFrame = null;
  var drawer = null;
  var observer = null;

  function validScore(value) {
    return typeof value === "number" && Number.isFinite(value) && value > 0 && value <= 10;
  }

  function readCache() {
    try {
      var cached = JSON.parse(window.localStorage.getItem(cacheKey));
      var age = cached && Date.now() - cached.ts;
      if (!cached || typeof cached.ts !== "number" || !Number.isFinite(age) ||
          age < 0 || !validScore(cached.avg)) return null;
      return { avg: cached.avg, fresh: age < cacheTTL };
    } catch (error) {
      return null;
    }
  }

  function applyScore() {
    if (currentScore === null) return;
    var value = (currentScore > 5 ? currentScore : currentScore * 2)
      .toFixed(1).replace(".", ",");
    document.querySelectorAll(selector).forEach(function (el) {
      var text = el.hasAttribute("data-tm-wwk-score") ? value + " / 10" : value;
      if (el.textContent !== text) el.textContent = text;
    });
  }

  function hasDemand() {
    return !!document.querySelector("[data-tm-wwk-score-value]") ||
      !!(drawer && drawer.classList.contains("is-active") && drawer.querySelector(selector));
  }

  async function fetchScore() {
    if (fresh || inFlight || attempts >= 2 || retryTimer !== null || !hasDemand()) return;
    inFlight = true;
    attempts += 1;
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 6000);
    try {
      var url = "https://dashboard.webwinkelkeur.nl/api/1.0/ratings_summary.json?id=" +
        encodeURIComponent(cfg.shopId) + "&public_code=" + encodeURIComponent(cfg.publicCode);
      var response = await fetch(url, { credentials: "omit", signal: controller.signal });
      if (!response.ok) throw new Error("Rating response unavailable");
      var json = await response.json();
      var avg = json && json.data && json.data.rating_average;
      if (!json || json.status !== "success" || !validScore(avg)) {
        throw new Error("Invalid rating response");
      }
      currentScore = avg;
      fresh = true;
      try {
        window.localStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), avg: avg }));
      } catch (error) {}
      applyScore();
    } catch (error) {
      if (attempts < 2) {
        retryTimer = window.setTimeout(function () {
          retryTimer = null;
          fetchScore();
        }, 1500);
      }
    } finally {
      window.clearTimeout(timeout);
      inFlight = false;
    }
  }

  function update() {
    applyScore();
    fetchScore();
  }

  function schedule() {
    if (pendingFrame !== null) return;
    pendingFrame = window.requestAnimationFrame(function () {
      pendingFrame = null;
      update();
    });
  }

  function containsScore(node) {
    return node.nodeType === 1 && (node.matches(selector) || !!node.querySelector(selector));
  }

  function onMutations(records) {
    var relevant = records.some(function (record) {
      if (record.type === "attributes") return record.target === drawer;
      return Array.from(record.addedNodes).some(containsScore);
    });
    if (relevant) schedule();
  }

  function refresh() {
    var next = document.getElementById("CartDrawer");
    if (observer) observer.disconnect();
    drawer = next;
    if (drawer && window.MutationObserver) {
      observer = observer || new MutationObserver(onMutations);
      observer.observe(drawer, { attributes: true, attributeFilter: ["class"] });
      var content = drawer.querySelector(".js-cart-content");
      if (content) observer.observe(content, { childList: true, subtree: true });
    }
    update();
  }

  function init() {
    var cached = readCache();
    if (cached) {
      currentScore = cached.avg;
      fresh = cached.fresh;
    }
    refresh();
  }

  window.TMWebwinkelkeurRating = { refresh: refresh };
  document.addEventListener("shopify:section:load", refresh);
  document.addEventListener("shopify:section:unload", function (event) {
    if (drawer && event.target.contains(drawer)) {
      if (observer) observer.disconnect();
      drawer = null;
    }
  });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();